// Handles authentication-based access

import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../reduxToolkit/hooks';
import { routes } from './routes';
import { UserRole } from '../types/Forms';

const PrivateRoute = () => {
  const { isAuthenticated, role } = useAppSelector((state) => state.auth);

  let route = routes.Login;

  if (role != null) {
    switch (role) {
      case UserRole.ADMIN:
      case UserRole.ASSISTANT:
        route = routes.Dashboard.Default;
        break;
      case UserRole.STUDENT:
        route = routes.Students.StudentPrivateCourses;
        break;
      default:
        route = routes.Login;
    }
  }

  return isAuthenticated ? <Navigate to={route} replace /> : <Outlet />;
};

export default PrivateRoute;
